<template>
  <div class="ibox">
    <div class="ibox-title">
      <pagination
          :items.sync="logContent"
          store-mutation="setLogs"
          :page-size="10"
          :max-pages="5"
          class="pull-right"
          ref="pagination"
          style="margin-top: -4px">
      </pagination>
      <div class="form-inline">
        <select class="form-control" v-model="currentFolder" @change="setFileToDefault">
          <option :value="folder" v-for="folder in Object.keys(logFiles)">{{ folder }}</option>
        </select>
        <select class="form-control" v-model="currentFile" @change="openFile">
          <option value="default" disabled>
            {{ $t('backend.logviewer.select_logfile') }}
          </option>
          <option :value="file" v-for="file in logFiles[currentFolder]">{{ file }}</option>
        </select>
        <button class="btn" @click="openFile" v-if="$store.getters.getLogs && currentFile !== 'default'">
          <i class="fa fa-refresh fa-fw" style="font-size: 18px" :class="{'fa-spin': loading}"></i>
        </button>
        <span class="sr-only">Loading...</span>
        </div>
    </div>
    <div class="ibox-content">
      <spinner v-if="loading"></spinner>
      <div class="alert alert-danger" v-if="error">
        {{ $t('backend.logviewer.error') }}
      </div>
      <table class="table table-hover" v-if="!loading && $store.getters.getLogs">
        <tbody>
        <tr>
          <th>Level</th>
          <th>Date</th>
          <th>Message</th>
        </tr>
        <tr v-for="(value, key) in $store.getters.getLogs">
          <td style="width: 50px">
            <span :class="getLabelClasses(value.level)">{{ value.level.toUpperCase() }}</span>
          </td>
          <td style="width: 150px">{{value.header}}</td>
          <td>
            <div class="panel-body" style="padding: unset;">
              <div class="panel-group" id="accordion">
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <p class="panel-title">
                      <a data-toggle="collapse" data-parent="#accordion" :href="`#collapse${key}`" class="collapsed"
                         aria-expanded="false">
                        {{value.message}}
                      </a>
                    </p>
                  </div>
                  <div :id="`collapse${key}`" class="panel-collapse collapse" style="" v-if="value.stack !== '<br />\n'">
                    <div class="panel-body" v-html="value.stack"></div>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Pagination from "../common/pagination/Pagination";
import Spinner from "../common/spinner/Spinner";

export default {
  name: "LogViewer",
  components: {Spinner, Pagination},
  data() {
    return {
      error: false,
      loading: false,
      logFiles: {},
      currentFolder: 'laravel',
      currentFile: 'default',
      logContent: ''
    }
  },
  methods: {
    getLogFiles() {
      this.error = false;
      this.loading = true;
      axios.get('/backend/logviewer/get-files').then((response) => {
        this.logFiles = response.data;
      }).then(() => {
        this.loading = false;
      }).catch(() => {
        this.error = true;
        this.loading = false;
      })
    },
    openFile() {
      this.error = false;
      this.loading = true;
      axios.post('/backend/logviewer/open-file', {
        file: this.currentFolder === 'laravel' ? this.currentFile : `${this.currentFolder}/${this.currentFile}`
      }).then((response) => {
        this.logContent = response.data;
      }).then(() => {
        this.$refs.pagination.setPage(1);
        this.loading = false;
      }).catch(() => {
        this.error = true;
        this.loading = false;
      })
    },
    getLabelClasses(level) {
      return {
        label: true,
        'label-danger': level === 'error' || level === 'emergency' || level === 'alert' || level === 'critical',
        'label-warning': level === 'warning',
        'label-info': level === 'info'
      };
    },
    setFileToDefault() {
      this.currentFile = 'default'
    }
  },
  mounted() {
    this.getLogFiles();
  },
}
</script>

<style scoped>
select {
  width: 700px;
}
a {
  font-weight: unset !important;
}
.panel-group {
  margin-bottom: unset;
}
</style>